import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../common/state';
import { selectOfferType } from '../../../filters/state/offer_type';
import { ESortValue } from '../../../json_query';
import { FOfferType } from '../../../utils/category';
import { changeSort } from '../../state/sort';
import { clearRailwayTags } from '../../state/geo';
import { ObjectType, IObjectTypeStateProps, IObjectTypeDispatchProps } from './ObjectType';

function mapStateToProps(state: IAppState): IObjectTypeStateProps {
  return {
    jsonQuery: state.filters.jsonQuery,
  };
}

function mapDispatchToProps(dispatch: Dispatch): IObjectTypeDispatchProps {
  return {
    onOfferTypeSelected: (type: FOfferType) => {
      dispatch(selectOfferType(type));
    },
    setDefaultSort: () => {
      /**
       * Хардкодим тут параметры, так как после каждой смены
       * типа объекта меняем тип сортировки на default
       */
      dispatch(changeSort(ESortValue.Default, true));
    },
    clearRailwayTags: () => {
      dispatch(clearRailwayTags());
    },
  };
}

export const ObjectTypeContainer = connect(mapStateToProps, mapDispatchToProps)(ObjectType);
